const playList = [
  {
    title: 'Truth of touch',
    src: './sounds/truth_of_touch.mp3',
  },
  {
    title: 'Anthem of Ukraine',
    src: './sounds/anthem_of_Ukraine.mp3',
  },
  {
    title: 'Nature - Rain',
    src: './sounds/rain.mp3',
  },
  {
    title: 'Nature - Birds',
    src: './sounds/birds.mp3',
  },
];
export default playList;
